export const hexToRGB = (hex: string, alpha?: string): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};

/* Fallback when a project has no assigned colour. Used by both its boundary fill and its location
   pin, so the two can never disagree. */
export const DEFAULT_PROJECT_COLOUR = "#FF865D";
